<template>
  <img
    v-if="!fallback"
    :src="src"
    height="40"
    width="40"
    @error="fallback = true"
  >
  <svg
    v-else
    height="40"
    width="40"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 511.998 511.998"
    xml:space="preserve"
  >
    <path
      style="fill:#AA968C;"
      d="M503.999,247.999c0,128.13-111.033,240-248,240S8,376.129,8,247.999s111.033-224,248-224
    S503.999,119.869,503.999,247.999z"
    />
    <path
      style="fill:#AA968C;"
      d="M255.999,23.999C119.033,23.999,8,119.868,8,247.999c0,24.631,4.138,48.647,11.74,71.397
    c25.518,34.29,66.232,56.602,112.26,56.602c53.893,0,100.6-30.495,124-75.13c23.4,44.636,70.107,75.13,124,75.13
    c46.028,0,86.743-22.312,112.26-56.602c7.602-22.75,11.74-46.767,11.74-71.397C503.999,119.868,392.966,23.999,255.999,23.999z"
    />
    <circle
      style="fill:#C8AF9B;"
      cx="256"
      cy="351.999"
      r="136"
    />
    <g>
      <circle
        style="fill:#464655;"
        cx="132"
        cy="203.999"
        r="28"
      />
      <circle
        style="fill:#464655;"
        cx="380"
        cy="203.999"
        r="28"
      />
      <path
        style="fill:#464655;"
        d="M269.949,284.516c-7.672,10.741-20.227,10.741-27.899,0l-12.101-16.941
      c-7.672-10.741-3.15-19.53,10.05-19.53h32c13.2,0,17.723,8.788,10.05,19.53L269.949,284.516z"
      />
    </g>
    <path
      style="fill:#AA968C;"
      d="M 350.964 399.998 C 316.628 399.998 299.021 351.998 255.882 351.998 C 212.742 351.998 195.135 399.998 160.801 399.998 C 145.395 399.998 131.723 394.147 120.621 374.798 C 131.595 439.03 187.893 487.998 255.881 487.998 C 323.868 487.998 380.168 439.03 391.14 374.798 C 380.04 394.148 366.368 399.998 350.964 399.998 Z"
    />
    <g>
      <path
        style="fill:#8C7873;"
        d="M32,423.998c-3.172,0-6.18-1.906-7.43-5.031c-1.641-4.105,0.359-8.758,4.461-10.402l160.008-64
      c4.062-1.617,8.758,0.352,10.398,4.457s-0.359,8.758-4.461,10.402l-160.008,64C34,423.811,32.992,423.998,32,423.998z"
      />
      <path
        style="fill:#8C7873;"
        d="M15.992,375.995c-3.547,0-6.781-2.375-7.727-5.965c-1.125-4.273,1.422-8.648,5.695-9.773l152-40
      c4.289-1.121,8.648,1.426,9.773,5.703c1.125,4.273-1.422,8.648-5.695,9.773l-152,40C17.351,375.913,16.672,375.995,15.992,375.995z
      "
      />
      <path
        style="fill:#8C7873;"
        d="M7.992,335.995c-3.812,0-7.187-2.73-7.867-6.609c-0.773-4.352,2.133-8.5,6.484-9.27l136-24
      c4.328-0.77,8.508,2.141,9.266,6.488c0.773,4.352-2.133,8.5-6.484,9.27l-136,24C8.922,335.956,8.453,335.995,7.992,335.995z"
      />
      <path
        style="fill:#8C7873;"
        d="M480,423.998c3.172,0,6.18-1.906,7.43-5.031c1.641-4.105-0.359-8.758-4.461-10.402l-160.008-64
      c-4.063-1.617-8.758,0.352-10.398,4.457s0.359,8.758,4.461,10.402l160.008,64C478,423.811,479.007,423.998,480,423.998z"
      />
      <path
        style="fill:#8C7873;"
        d="M496.007,375.995c3.547,0,6.781-2.375,7.727-5.965c1.125-4.273-1.422-8.648-5.695-9.773l-152-40
      c-4.289-1.121-8.648,1.426-9.773,5.703c-1.125,4.273,1.422,8.648,5.695,9.773l152,40
      C494.648,375.913,495.328,375.995,496.007,375.995z"
      />
      <path
        style="fill:#8C7873;"
        d="M504.007,335.995c3.813,0,7.188-2.73,7.867-6.609c0.773-4.352-2.133-8.5-6.484-9.27l-136-24
      c-4.328-0.77-8.508,2.141-9.266,6.488c-0.773,4.352,2.133,8.5,6.484,9.27l136,24C503.078,335.956,503.546,335.995,504.007,335.995z
      "
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ProjectLogo',
  props: {
    src: {
      type: String,
      default: '/brand-logo.svg'
    }
  },
  data() {
    return {
      fallback: false
    }
  }
}
</script>
